
<div class="appComponent">
    <router-outlet></router-outlet>
</div>